import { render } from "./SliderMain2.vue?vue&type=template&id=0a493e03&scoped=true"
import script from "./SliderMain2.vue?vue&type=script&scoped=true&lang=js"
export * from "./SliderMain2.vue?vue&type=script&scoped=true&lang=js"

import "./SliderMain2.vue?vue&type=style&index=0&id=0a493e03&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a493e03"]])

export default __exports__